import { HYPERFLOW_CREDENTIALS_LOADED, HYPERFLOW_ACCESS_CHANGED } from './actionTypes';

export const hyperflowCredentialsLoaded = (access: string) => ({
  type: HYPERFLOW_CREDENTIALS_LOADED,
  payload: { access }
});

export const hyperflowAccessChanged = (access: string) => ({
  type: HYPERFLOW_ACCESS_CHANGED,
  payload: { access }
});
